import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { ButtonSelector } from 'planoplan-ui-kit/core/buttonSelector';

const IconEmail = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.47619"
      y="4.97619"
      width="19.0476"
      height="14.0476"
      rx="1.52381"
      stroke="white"
      strokeWidth="0.952381"
      strokeLinejoin="round"
    />
    <path d="M3 5.5L12 12.5L21 5.5" stroke="white" strokeLinejoin="round" />
  </svg>
);

export const B2BCommand = () => {
  const translations = useTranslations();

  return (
    <View>
      <Top>
        <Title>{translations.t('site.home.b2b.command.title')}</Title>
        <Text>{translations.t('site.home.b2b.command.text')}</Text>
      </Top>
      <Bottom>
        <Picture>
          <source srcSet="/images/home/b2b/command.webp" type="image/webp" />
          <Image src="/images/home/b2b/command.png" alt="" />
        </Picture>

        <ButtonSelector
          theme="primary"
          size={'M'}
          isDarkMode={false}
          blank
          options={[
            {
              name: translations.t(`site.manufacturer.selectVariant.tg`),
              href: translations.t(`site.business_link_tg`),
              target: '_blank',
            },
            {
              name: translations.t(`site.manufacturer.selectVariant.email`),
              href: translations.t(`site.business_link_email`),
              target: '_blank',
            },
          ]}>
          <IconEmail /> {translations.t('site.home.b2b.command.button')}
        </ButtonSelector>
      </Bottom>
    </View>
  );
};

const View = styled.div`
  background-color: ${Colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 20px;
  padding: 16px 16px 30px;
  margin-bottom: 16px;

  @media ${Points.tablet_portrait} {
    width: 50%;
    height: auto;
    margin-bottom: 0;
  }

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
    margin-right: 20px;
    padding: 30px;
    width: 60%;
    max-width: 760px;
  }

  @media ${Points.laptop_wide} {
    margin-right: 15px;
    padding: 40px;
  }
`;
const Top = styled.div`
  margin-bottom: 43px;
`;
const Title = styled.div`
  font-size: 18px;
  line-height: 1.1;
  color: ${Colors.main_black};
  margin-bottom: 20px;
  font-weight: 500;

  @media ${Points.tablet_landscape} {
    font-size: 20px;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
  }
`;
const Text = styled.div`
  font-size: 16px;
  line-height: 1.3;

  @media ${Points.laptop_wide} {
    padding-right: 10px;
  }
`;
const Bottom = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  button > svg {
    margin-right: 10px;
  }

  @media ${Points.tablet_landscape} {
    align-items: flex-end;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
`;
const Picture = styled.picture`
  margin-bottom: 50px;
  max-width: 450px;
  width: 100%;

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
    height: 160px;
    max-width: none;
    width: auto;
  }

  @media ${Points.laptop_wide} {
    height: 240px;
  }
`;

const Image = styled.img`
  width: 100%;

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
    height: 160px;
    max-width: none;
    width: auto;
  }

  @media ${Points.laptop_wide} {
    height: 240px;
  }
`;
